import { toPublicURL } from '@plone/volto/helpers';
import { SchemaOrg, SchemaOrgUtils } from '@package/helpers/SchemaOrg';
import { viewDate } from 'design-comuni-plone-theme/helpers';

const addIfValid = (schemaOrg, key, value) => {
  if (value && value !== '') {
    schemaOrg[key] = value;
  }
};

const BandoSchemaOrg = ({ content }) => {
  let schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
  };
  addIfValid(schemaOrg, 'title', content.title);
  addIfValid(schemaOrg, 'description', content.description);
  addIfValid(schemaOrg, 'url', toPublicURL(content['@id']));
  addIfValid(
    schemaOrg,
    'employerOverview',
    SchemaOrgUtils.fieldDataToPlainText(content.text),
  );
  addIfValid(schemaOrg, 'employmentType', content.tipologia_bando?.title);
  addIfValid(
    schemaOrg,
    'datePosted',
    viewDate('data', content.effective, 'DD-MM-YYYY'),
  );
  addIfValid(
    schemaOrg,
    'validThrough',
    viewDate('data', content.expires, 'DD-MM-YYYY'),
  );
  addIfValid(schemaOrg, 'additionalInformation', content.additionalInformation);

  if (
    content.ufficio_responsabile?.length > 0 ||
    content.area_responsabile?.length > 0
  ) {
    schemaOrg.employmentUnit = {
      '@type': 'Organization',
    };
    addIfValid(
      schemaOrg.employmentUnit,
      'name',
      content.ufficio_responsabile[0]?.title,
    );
    addIfValid(schemaOrg.employmentUnit, 'department', {
      '@type': 'Organization',
      name: content.area_responsabile[0]?.title,
    });
  }
  schemaOrg.hiringOrganization = {
    '@type': 'Organization',
    name: 'Azienda Unità Sanitaria Locale della Romagna',
  };

  return <SchemaOrg content={content} schema={schemaOrg} />;
};

export default BandoSchemaOrg;
